import { useState } from "react";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { IVignetteProps } from "pages/[tenant]/browse/components/Vignette";
import { MediaBackground } from "pages/[tenant]/browse/components/Vignette/components/MediaBackground";
import { SoundButton } from "pages/[tenant]/browse/components/Vignette/components/SoundButton";
import useBillboardPageContext from "pages/[tenant]/browse/hooks/useBillboardPageContext";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { getUserBrowserName } from "shared/utils/getUserBrowserName";
import useWindowSize from "shared/utils/hooks/useWindowSize";

import { BackgroudPlayerContainer, SeeMoreButton } from "./styles";

const BackgroudPlayerContent = (props?: IVignetteProps) => {
  const { backgroundContent, hasSound, group } = useBillboardPageContext();
  const [_, setImageFailedToLoad] = useState(false);

  const { push } = useRouter();

  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const groupSlugParam = group?.slug ? `/${group?.slug}` : "";

  const handleRedirectToGroup = () => {
    if (isMobile) push(`/g${groupSlugParam}`);
  };

  const handleError = () => {
    setImageFailedToLoad(true);
    setTimeout(() => setImageFailedToLoad(false), 50);
  };

  const userBrowser = getUserBrowserName();

  const userBrowserIsGoogleChrome = userBrowser === "chrome";
  const userBrowserIsOpera = userBrowser === "opera";
  const userBrowserIsEdge = userBrowser?.includes("edge");

  const shouldRemoveSoundButton =
    userBrowserIsGoogleChrome || userBrowserIsOpera || userBrowserIsEdge;

  return (
    <BackgroudPlayerContainer
      backgroundContent={backgroundContent}
      group={group}
      hasSound={hasSound}
      onClick={handleRedirectToGroup}
    >
      <ComponentErrorBoundary>
        <MediaBackground
          key={`${group?.created_at}-${group?.slug}-${group?.id}`}
        />
      </ComponentErrorBoundary>

      {props?.renderBackgroundGradientOutsideContent && (
        <div className="background-linear-gradient" />
      )}

      <div className="content">
        {!props?.renderBackgroundGradientOutsideContent && (
          <div className="background-linear-gradient" />
        )}

        <div className="billboard-presentation-container">
          <div className="info-container">
            {!!group?.title_image ? (
              <div className="title-image">
                <Image
                  src={group?.title_image}
                  onError={handleError}
                  alt=""
                  fill
                  fetchPriority="high"
                  priority
                  quality={60}
                />
              </div>
            ) : (
              <h1 title={group?.title}>{group?.title}</h1>
            )}

            {group?.kicker && <span className="badge">{group.kicker}</span>}

            <span className="subtitle" title={group?.subtitle}>
              {group?.subtitle}
            </span>

            <div
              className="buttons-container"
              id="billboard-play-buttons-container"
            >
              <Link href={`/g${groupSlugParam}`} prefetch={false}>
                <SeeMoreButton>Saiba mais</SeeMoreButton>
              </Link>
            </div>
          </div>

          {!shouldRemoveSoundButton && <SoundButton />}
        </div>

        {!!props?.aditionalContent && (
          <ComponentErrorBoundary>
            {props?.aditionalContent}
          </ComponentErrorBoundary>
        )}
      </div>
    </BackgroudPlayerContainer>
  );
};

export default BackgroudPlayerContent;
